function Contact() {
  return <div className="bg-purple h-screen">Contact</div>;
}

export default Contact;
